<template>
  <div class="projectPage">
    <Header
      :menuIndex="1"
      :banner="bannerImg"
      mainTitle="岩土工程勘察文件自动化系统"
      subTitle="岩土工程勘察文件自动化系统"
    />
    <div class="navBar">
      <div class="container">
        <div
          class="item"
          v-for="(item, index) in navBarList"
          :key="index"
          :class="{ active: activeIndex == index }"
          @click="changeActiveIndex(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="container" ref="sectionA">
      <section class="sectionA">
        <div class="sec-title">{{ navBarList[0] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionAList" :key="index">
            <img :src="item.img" alt="" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="sectionB" ref="sectionB">
      <div class="container">
        <div class="sec-title">{{ navBarList[1] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionBList" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>
    <div class="container" ref="sectionC">
      <section class="sectionC">
        <div class="sec-title">{{ navBarList[2] }}</div>
        <div class="sec-sub-title">
          自定义配置，一键生成勘察报告
        </div>
        <div class="content">
          <div class="tabs">
            <div
              class="item"
              :class="{ active: sectionCActiveIndex == index }"
              v-for="(item, index) in sectionCList"
              :key="index"
              @click="changeSectionC(index)"
            >
              <div class="tab" v-if="sectionCActiveIndex != index">
                {{ item.title }}
              </div>
              <div class="detail" v-if="sectionCActiveIndex == index">
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <span v-for="(item_s, indes_s) in item.desc" :key="indes_s">{{
                    item_s
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <img :src="sectionCList[sectionCActiveIndex].img" alt="" />
        </div>
      </section>
    </div>
    <div class="contactus">
      <div class="title">从这里开始，让数据用起来</div>
      <div class="btn" @click="$router.push('/application')">联系我们</div>
    </div>
    <Foot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerImg: require("@/assets/banner/5.jpg"),
      navBarList: ["产品优势", "核心功能", "产品展示"],
      activeIndex: 0,
      sectionAList: [
        {
          img: require("@/assets/chanpinyoushi/1.png"),
          title: "自动化勘察报告生成",
          desc:
            "用户通过录入项目工程信息和设置报告目录，一键生成完整的勘察报告，大大节省了勘察报告编写的时间和精力 ",
        },
        {
          img: require("@/assets/chanpinyoushi/2.png"),
          title: "多样化的附件生成",
          desc:
            "不仅支持生成勘察报告，还可以生成报告审核意见卡、归档清单、项目负责人证件等各类与勘察资料相关的附件，满足用户全方位的文件需求",
        },
        {
          img: require("@/assets/chanpinyoushi/3.png"),
          title: "灵活的模块定制",
          desc:
            "在软件后台自主创建章节模块，根据具体项目需求进行定制，使得勘察报告的结构和内容更加灵活和个性化",
        },
        {
          img: require("@/assets/chanpinyoushi/4.png"),
          title: "智能化的地质参数记录",
          desc:
            "自动记录地质参数，随着使用次数的增加，软件逐渐学习并提供更准确和便捷的地质参数录入和管理功能，提高了数据的准确性和可靠性",
        },
        {
          img: require("@/assets/chanpinyoushi/5.png"),
          title: "高度集成的数据库",
          desc:
            "GA数据库紧密链接，实现数据的无缝连接和共享，确保勘察数据的完整性和一致性，在数据管理和查询方面具有优势",
        },
        {
          img: require("@/assets/chanpinyoushi/6.png"),
          title: "用户友好的界面和操作",
          desc:
            "拥有用户友好的界面设计和操作方式，简化了用户的学习曲线，使得用户能够轻松上手并高效地操作软件，提升工作效率",
        },
      ],
      sectionBList: [
        {
          img: require("@/assets/hexingongneng/1.png"),
          title: "数据安全与权限管理",
          desc:
            "重视数据安全和权限管理，确保用户的勘察数据和敏感信息得到保护。通过严格的权限控制，只有授权的人员才能访问和修改数据",
        },
        {
          img: require("@/assets/hexingongneng/2.png"),
          title: "附件管理与生成",
          desc:
            "不仅可以生成勘察报告，还可以管理和生成与勘察资料相关的各类附件，如报告审核意见卡、归档清单和项目负责人证件等，提供全面的文档管理功能",
        },
        {
          img: require("@/assets/hexingongneng/3.png"),
          title: "辅助勘察设计",
          desc:
            "帮助工程师进行勘察设计，包括确定勘察点位、勘察范围、勘察方法等，同时还能生成勘察任务计划和工作流程",
        },
        {
          img: require("@/assets/hexingongneng/4.png"),
          title: "灵活的章节模块定制",
          desc:
            "在软件后台灵活创建和定制章节模块，根据具体项目的需求自主设计报告结构，实现个性化的报告编制，满足不同项目的要求",
        },
        {
          img: require("@/assets/hexingongneng/5.png"),
          title: "智能地质参数记录",
          desc:
            "具备智能地质参数记录功能，根据用户的输入和使用次数，软件逐渐学习和自动记录地质参数，提供准确和便捷的参数录入和管理",
        },
        {
          img: require("@/assets/hexingongneng/6.png"),
          title: "数据库链接与一键生成",
          desc:
            "将勘察数据转化为数据库格式，并自动生成GA数据库，提供便捷的数据管理和查询功能。用户只需录入项目信息，设置报告目录，即可一键生成勘察报告和相关数据库",
        },
      ],
      sectionCList: [
        {
          title: "连接YTKC数据库",
          desc: ["自动生成GA数据库"],
          img: require("@/assets/auto/show1.png"),
        },
        {
          title: "录入工程信息",
          desc: ["多项配置", "智能分析"],
          img: require("@/assets/auto/show2.png"),
        },
        {
          title: "生成勘察报告",
          desc: ["标准化报告", "自主创建章节"],
          img: require("@/assets/auto/show4.png"),
        },
        {
          title: "多样化附件",
          desc: ["审核意见卡", "归档清单", "项目负责人证件"],
          img: require("@/assets/auto/show3.png"),
        },
      ],
      sectionCActiveIndex: 0,
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 0;
        }
      });
    }, options);

    observer1.observe(this.$refs.sectionA);

    const observer2 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 1;
        }
      });
    }, options);

    observer2.observe(this.$refs.sectionB);

    const observer3 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 2;
        }
      });
    }, options);

    observer3.observe(this.$refs.sectionC);
  },
  methods: {
    changeActiveIndex(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.$refs.sectionA.scrollIntoView({ behavior: "smooth" });
          break;
        case 1:
          this.$refs.sectionB.scrollIntoView({ behavior: "smooth" });
          break;
        case 2:
          this.$refs.sectionC.scrollIntoView({ behavior: "smooth" });
          break;
      }
    },
    changeSectionC(index) {
      this.sectionCActiveIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1280px;
  margin: 0 auto;
}
.projectPage {
  .navBar {
    height: 55px;
    position: sticky;
    z-index: 100;
    top: 0;
    background-color: #fff;
    box-shadow: 0 1px 1px 0 #ebedf6;
    > .container {
      display: flex;
      align-items: center;
      .item {
        cursor: pointer;
        margin-right: 50px;
        font-size: 16px;
        line-height: 55px;
        color: #7a8ba6;
        position: relative;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-image: linear-gradient(90deg, #659eff 0, #2466ff 100%);
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 0;
          transition: all 0.3s;
        }
      }
      .item.active {
        &::after {
          opacity: 1;
        }
      }
    }
  }
  section {
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      width: 100%;
      padding-bottom: 72px;
      padding-top: 72px;
    }
  }
  .sectionA {
    padding-bottom: 72px;
    & > .content {
      display: grid;
      column-gap: 150px;
      row-gap: 70px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 132px 132px;
      .item {
        display: flex;
        img {
          width: 30px;
          height: 30px;
          margin-right: 15px;
        }
        .info {
          .title {
            color: #374567;
            font-size: 18px;
            font-weight: 600;
            line-height: 32px;
          }
          .desc {
            margin-top: 16px;
            color: #7a8ba6;
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            line-height: 24px;
            text-align: justify;
          }
        }
      }
    }
  }
  .sectionB {
    width: 100%;
    background-color: #f9faff;
    padding-bottom: 80px;
    .content {
      display: grid;
      column-gap: 25px;
      row-gap: 25px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 344px 344px;
      .item {
        position: relative;
        background-color: #fff;
        img {
          position: absolute;
          width: 148px;
          height: 148px;
          bottom: 5px;
          right: 14px;
        }
        .title {
          font-weight: 600;
          margin-left: 32px;
          margin-top: 32px;
          height: 32px;
          font-size: 18px;
          color: #374567;
          line-height: 32px;
          text-align: left;
        }
        .desc {
          margin-right: 32px;
          padding-top: 8px;
          margin-left: 32px;
          letter-spacing: 1.5px;
          font-size: 14px;
          text-align: justify;
          color: #7a8ba6;
          line-height: 24px;
        }
      }
    }
  }
  .sectionC {
    width: 100%;
    padding-bottom: 80px;
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      padding: 70px 0 0 0;
    }
    .sec-sub-title {
      font-size: 14px;
      color: #7a8ba6;
      line-height: 24px;
      max-width: 1280px;
      margin: 24px auto 72px auto;
      text-align: center;
    }
    .content {
      width: 100%;
      .tabs {
        width: 100%;
        display: flex;
        background-color: #f9faff;
        .item {
          flex: 1;
          height: 136px;
          cursor: pointer;
          .tab {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #374567;
            font-weight: 500;
            text-align: center;
          }
          .detail {
            .title {
              margin-top: 32px;
              margin-left: 24px;
              font-weight: 600;
              font-size: 18px;
              color: #374567;
              line-height: 24px;
              text-align: left;
              height: 24px;
              width: 352px;
            }
            .desc {
              margin-top: 10px;
              margin-left: 24px;
              font-size: 14px;
              color: #7a8ba6;
              line-height: 24px;
              span {
                margin-right: 12px;
              }
            }
          }
        }
        .item.active {
          width: 455px;
          height: 136px;
          border-top: 4px solid #2468ff;
          background-color: #fff;
        }
      }
      img {
        width: 100%;
        height: 720px;
      }
    }
  }
  .contactus {
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(
      90deg,
      rgb(251, 252, 255),
      rgb(228, 234, 252) 75%,
      rgb(202, 222, 255)
    );
    .title {
      font-size: 30px;
      line-height: 40px;
      letter-spacing: 1.88px;
      text-align: center;
      color: #181818;
      padding-top: 49px;
      font-weight: 500;
    }
    .btn {
      margin-top: 20px;
      width: 108px;
      height: 36px;
      border-radius: 18px;
      background-image: linear-gradient(
        90deg,
        rgb(124, 172, 255),
        rgb(98, 140, 255)
      );
      margin: 20px auto;
      font-size: 14px;
      color: #fff;
      line-height: 36px;
      cursor: pointer;
      text-align: center;
      &:hover {
        background-image: linear-gradient(
          90deg,
          rgb(113, 165, 255),
          rgb(78, 125, 252)
        );
      }
    }
  }
}
</style>
